var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7.71 13.29a.996.996 0 01-1.41 0L2.71 9.7a.996.996 0 111.41-1.41L7 11.17l6.88-6.88a.996.996 0 111.41 1.41l-7.58 7.59z",
    fill: "#000"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDxwYXRoIGQ9Ik0xNiAwSDJDMC45IDAgMCAwLjkgMCAyVjE2QzAgMTcuMSAwLjkgMTggMiAxOEgxNkMxNy4xIDE4IDE4IDE3LjEgMTggMTZWMkMxOCAwLjkgMTcuMSAwIDE2IDBaTTcuNzEgMTMuMjlDNy4zMiAxMy42OCA2LjY5IDEzLjY4IDYuMyAxMy4yOUwyLjcxIDkuN0MyLjMyIDkuMzEgMi4zMiA4LjY4IDIuNzEgOC4yOUMzLjEgNy45IDMuNzMgNy45IDQuMTIgOC4yOUw3IDExLjE3TDEzLjg4IDQuMjlDMTQuMjcgMy45IDE0LjkgMy45IDE1LjI5IDQuMjlDMTUuNjggNC42OCAxNS42OCA1LjMxIDE1LjI5IDUuN0w3LjcxIDEzLjI5WiIgZmlsbD0iYmxhY2siIGZpbGxPcGFjaXR5PSIwLjg3IiAvPgo8L3N2Zz4=";
export { SvgCheckboxChecked as ReactComponent };